module.exports = __webpack_public_path__ + "assets/img/img-detail-sp.03ec7809.jpg";